// extracted by mini-css-extract-plugin
export default {"badge-button-wrapper":"_274x2","badgeButtonWrapper":"_274x2","badge-button":"_6ZO7M","badgeButton":"_6ZO7M","badge":"_3ZDno"};